/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { GroupHighscore, UserGroupDefaultHighscoreRound } from '../../services/betting';
import {
    GroupHighscorePagingValues,
    groupHighscoresSetDefaultRound,
    groupHighscoresSetIsLoading,
    groupHighscoresSetTrId,
    setGroupHighscores,
    setGroupHighscoreSearchString,
    setGroupHighscoresPagingValues
} from './actions';

export interface GroupHighscoreStore {
    trId?: string;
    highscores: GroupHighscore[];
    count: number;
    current: number;
    slotSize: number;
    priorEnabled: boolean;
    nextEnabled: boolean;
    searchString: string;
    isLoading: boolean;

    defaultHighscoreRounds: { [ugId: string]: UserGroupDefaultHighscoreRound };
}

export const initialGroupHighscoreState: GroupHighscoreStore = {
    trId: undefined,
    highscores: [],
    count: 0,
    current: 0,
    slotSize: 20,
    priorEnabled: false,
    nextEnabled: false,
    searchString: '',
    defaultHighscoreRounds: {},
    isLoading: false
};

export function groupHighscoreReducer(state: GroupHighscoreStore = initialGroupHighscoreState, action: Action): GroupHighscoreStore {
    if (isType(action, setGroupHighscores)) {
        return Object.assign({}, state, { highscores: action.payload });
    } else if (isType(action, setGroupHighscoresPagingValues)) {
        let params: GroupHighscorePagingValues = action.payload;
        return Object.assign({}, state, {
            nextEnabled: params.forwardEnabled,
            priorEnabled: params.backwardEnabled,
            count: params.count,
            current: params.current
        });
    } else if (isType(action, setGroupHighscoreSearchString)) {
        return Object.assign({}, state, { searchString: action.payload });
    } else if (isType(action, groupHighscoresSetTrId)) {
        return { ...state, trId: action.payload };
    } else if (isType(action, groupHighscoresSetIsLoading)) {
        return { ...state, isLoading: action.payload };
    } else if (isType(action, groupHighscoresSetDefaultRound)) {
        const defaultHighscoreRounds = { ...state.defaultHighscoreRounds, [action.payload.ugId]: action.payload.tr };
        return { ...state, defaultHighscoreRounds };
    }

    return state;
}
